import styled from 'styled-components'
import { flexMixin, loadingStateBackgroundMixin } from '~common'
import { PharmaspectraBrandLogo } from '~shared/ui/molecules/brand-logo'

export const StyledHeader = styled.header`
  ${flexMixin}
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100vw;
  background: ${({ theme }) => theme.colors.navigation.navPrimary};
  &:focus {
    outline: none;
  }
`

export const StyledHeaderLoadingBlock = styled.header`
  height: 4.7375rem;
  width: 100%;
  ${loadingStateBackgroundMixin}
`

export const StyledPharmaspectraBrandLogo = styled(PharmaspectraBrandLogo)`
  padding-left: 1rem;
`

export const StyledRegeneronIconWrapper = styled.span`
  margin-left: 1rem;
  margin-top: 1rem;
`
